import React, { useRef, useState } from "react";
import {
  Container,
  Typography,
  Button,
  TextField,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { updateUser } from "../../api-interactions/authentication";

export const SignupAdditional = (props) => {
  const fnameRef = useRef();
  const lnameRef = useRef();
  const displayNameRef = useRef();

  const [error, setError] = useState("");

  const submitHandler = async (e) => {
    e.preventDefault();

    const firstName =
      fnameRef.current.value[0].toUpperCase() +
      fnameRef.current.value.substring(1);
    const lastName =
      lnameRef.current.value[0].toUpperCase() +
      lnameRef.current.value.substring(1);

    const err = await updateUser({
      firstName,
      lastName,
      userName: displayNameRef.current.value.toLowerCase(),
    });
    if (err === undefined) {
      props.setActiveStep(2);
    } else {
      setError(err);
    }
    setTimeout(() => {
      setError("");
    }, 6000);
  };

  return (
    <Container id="signin-container" maxWidth="xs">
      <Typography id="signin-text" component="h1" variant="h5">
        Add some details
      </Typography>
      {error && (
        <Snackbar open={true} autoHideDuration={6000}>
          <Alert severity="error">{error}</Alert>
        </Snackbar>
      )}
      <form id="signin-form">
        <TextField
          inputRef={fnameRef}
          type="text"
          required
          variant="outlined"
          label="First name"
          className="signin-form-input"
        />
        <TextField
          inputRef={lnameRef}
          type="text"
          required
          variant="outlined"
          label="Last name"
          className="signin-form-input"
        />
        <TextField
          inputRef={displayNameRef}
          type="text"
          required
          variant="outlined"
          label="Username"
          className="signin-form-input"
        />
        <Button
          onClick={submitHandler}
          type="submit"
          variant="contained"
          color="primary"
          id="signin-btn"
        >
          Confirm
        </Button>
      </form>
    </Container>
  );
};
